// extracted by mini-css-extract-plugin
export default {"wrapper":"imageUnavailable_wrapper__6mjQ0","img-placeholder":"imageUnavailable_img-placeholder__OBt9N","round":"imageUnavailable_round__HN6w-"};